const scope_0 = require('/Users/vojtechholik/Documents/Work/egghead/Dev/how-to-egghead/.cache/gatsby-mdx/mdx-scopes-dir/bbb48316d5194c9d570835d74a598f55.js').default;
const scope_1 = require('/Users/vojtechholik/Documents/Work/egghead/Dev/how-to-egghead/.cache/gatsby-mdx/mdx-scopes-dir/e43fb7ea8e5c973fc291302acf6043f3.js').default;export default {
  ...scope_0,
...scope_1
}